import { Center } from '@chakra-ui/react';
import { colors } from '@theme/foundations/colors';

import { SensorSection } from '../../../GlobalTab';
import HolopticsBaieSchematic from './HolopticsBaieSchematic';
import HolopticsCameraSchematic from './HolopticsCameraSchematic';
import HolopticsCoffretSchematic from './HolopticsCoffretSchematic';

export const commonHolopticsI18nPath = 'components.monitoring.sensorDetail.global.holoptics';

export default function HolopticsSchematic(): SensorSection {
  return [
    <Center key="holoptics-schematic" backgroundColor="neutral.850" paddingY={8} width="100%" textStyle="xs">
      <svg width="1219" height="519" viewBox="0 0 1219 519" fill="none">
        <rect width="40" height="40" transform="translate(12 19)" fill={colors.skyBlue.DEFAULT.value} />
        <path
          d="M34 36.7381L33.9999 25L26 42.4999L31 41.1458L31 53L38 35.5001L34 36.7381Z"
          fill={colors.neutral.white.value}
        />
        <path
          d="M34.999 25V35.3818L39.7061 33.9248L32.0762 53H29.999V42.4521L24.2031 44.0225L32.8994 25H34.999ZM27.7939 40.9775L31.999 39.8389V47.8066L36.291 37.0742L32.999 38.0947V29.5918L27.7939 40.9775Z"
          fill={colors.neutral.black.value}
        />
        <HolopticsBaieSchematic />
        <HolopticsCoffretSchematic />
        <HolopticsCameraSchematic />
      </svg>
    </Center>,
    null,
  ];
}
